import { Link } from "react-router-dom";
import { LGAS } from "@/lib/data";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#0B0C0E] mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <img src="/nasarawa-mark.png" alt="Nasarawa Expo" className="w-10 h-10 object-contain" />
            <div className="font-heading font-extrabold text-lg">NASARAWA EXPO</div>
          </div>
          <p className="text-zinc-400 text-sm max-w-md leading-relaxed">
            A creative movement uniting artists, designers, performers and innovators across
            all 13 Local Government Areas of Nasarawa State. Register, get discovered, get hired.
          </p>
        </div>
        <div>
          <div className="overline-label mb-4">Explore</div>
          <ul className="space-y-2.5 text-sm text-zinc-400">
            <li><Link to="/directory" className="hover:text-[#E6197E]">Member Directory</Link></li>
            <li><Link to="/leadership" className="hover:text-[#E6197E]">Leadership & EXCO</Link></li>
            <li><Link to="/events" className="hover:text-[#E6197E]">Events</Link></li>
            <li><Link to="/news" className="hover:text-[#E6197E]">News</Link></li>
            <li><Link to="/register" className="hover:text-[#E6197E]">Join the Movement</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline-label mb-4">13 LGAs</div>
          <div className="flex flex-wrap gap-1.5">
            {LGAS.map((l) => (
              <span key={l} className="text-[11px] px-2 py-0.5 rounded bg-white/5 text-zinc-400">{l}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-zinc-500">
        © 2026 Nasarawa Expo Creative Movement. All rights reserved.
      </div>
    </footer>
  );
}
